package de.jensklingenberg.showdown.model

// Fibonacci
val fibo = (listOf("0", "1", "2", "3", "5", "8", "13", "21", "34", "55", "89", "?"))

//Modified Fibonacci
val modFibo = (listOf("0", "1/2", "1", "2", "3", "5", "8", "13", "20", "40", "100", "?"))

//Values of the power of 2
val powerOf2 = (listOf("0", "1", "2", "4", "8", "16", "32", "64", "?"))

//Values of T-Shirt sizes
val tshirtSizesList = (listOf("xxs", "xs", "s", "m", "l", "xl", "xxl", "?"))

